import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentLang: localStorage.getItem('lang') || 'ar', // Initialize from Local Storage
    token: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    toggleLanguage(state) {
      state.currentLang = state.currentLang === 'ar' ? 'en' : 'ar';
      localStorage.setItem('lang', state.currentLang); // Store in Local Storage
    },
  },
  actions: {
    updateToken({ commit }, token) {
      commit('setToken', token);
    },
  },
  getters: {
    getToken: (state) => state.token,
  },
});

export default store;